<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @apply="applyApi"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <b-button
          v-if="allow('A')"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditPage({ pageType: 'add' })"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>

        <el-badge
          v-if="allow('B')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('B')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="updateDesignVisible = true"
          >
            {{ $l('INDEX.btn_change_design_name') || '企划人员调整' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <el-badge
          v-if="allow('E')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('E')"
            size="sm"
            style="margin-left:10px"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="updateMerchandiserVisible = true"
          >
            {{ $l('btn_updateMerchandiser') || '业务开发调整' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>

        <el-badge
          v-if="allow('F')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('F')"
            size="sm"
            style="margin-left:10px"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="apply"
          >
            {{ $l('btn_applyFullMember') || '申请转正' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <ChangeDesign
      v-if="updateDesignVisible"
      :visible.sync="updateDesignVisible"
      @confirm="confirm"
    />
    <ChangeMerchandiser
      v-if="updateMerchandiserVisible"
      :visible.sync="updateMerchandiserVisible"
      @confirm="confirm"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import ChangeDesign from '@/views/ecom/components/change-design'
import ChangeMerchandiser from '../change-merchandiser'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, ChangeDesign, ChangeMerchandiser },
  data() {
    return {
      usePage: true,
      updateDesignVisible: false,
      updateMerchandiserVisible: false,
      checkedRows: [],
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzSpuListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-base-awsspu-detail',
        params: { ...params, pageType },
        query,
      })
    },
    async confirm(form) {
      if (!this.checkedRowCount) {
        this.$message({
          message: '请选择需要调整数据的产品',
          type: 'warning',
        })
        return
      }

      if (this.loadingOpen()) return
      const listCode = this.checkedRows.map((item) => item.amzSpuCode)
      let res
      if (this.updateDesignVisible) {
        res = await this.$api
          .ecomAmzSpuFullMemberApi({ listCode, ...form })
          .catch(() => null)
      }
      if (this.updateMerchandiserVisible) {
        res = await this.$api
          .ecomAmzSpuChangeMerchandiserApi({ listCode, ...form })
          .catch(() => null)
      }
      this.loadingClose()
      if (!res) return
      const { status, msg } = res
      if (status !== 200) {
        this.$message.error(msg)
        return
      }
      this.$message({
        showClose: true,
        message: msg,
        type: 'success',
      })
      this.reload()
      this.updateDesignVisible = false
      this.updateMerchandiserVisible = false
      this.clearCheckboxRow()
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    apply() {
      if (!this.checkedRowCount) {
        this.$message({
          message: '请选择需要申请转正的SPU',
          type: 'warning',
        })
        return
      }
      const listAmzSpuCode = this.checkedRows.map((row) => row.amzSpuCode)
      this.applyApi(listAmzSpuCode)
    },
    async applyApi(listAmzSpuCode) {
      const confirm = await this.$confirm(
        '是否要申请转正？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzSpuApplyApi({ listAmzSpuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('申请失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '申请成功！',
        type: 'success',
      })
      this.reload()
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
